const revealLinks = document.querySelectorAll("[data-reveal]");
const overflowLinks = document.querySelectorAll(".overflow-link");
const overflowMenus = document.querySelectorAll(".overflow");

if (revealLinks.length || overflowMenus.length || overflowLinks.length) {
  // listener for opener
  for (const revealLink of revealLinks) {
    revealLink.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const target = document.querySelector(`.${this.dataset.reveal}`);

      target.classList.toggle("active");
      target.setAttribute("aria-hidden", false);
      revealLink.setAttribute("aria-expanded", true);
    });
  }

  for (const overflowLink of overflowLinks) {
    overflowLink.addEventListener("click", (e) => e.stopPropagation());
  }

  // close if clicking outside
  window.addEventListener("click", function () {
    for (const overflowMenu of overflowMenus) {
      overflowMenu.classList.remove("active");
      overflowMenu.setAttribute("aria-hidden", true);
    }
    for (const toggle of revealLinks) {
      toggle.setAttribute("aria-expanded", false);
    }
  });
}
